/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./settings.defs.js";
export { main as default } from "./settings.defs.js";
